webpackJsonp([23718644409033],{

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic01.78d2c532.jpg";

/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic09.b598bd94.jpg";

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic10.9354976d.jpg";

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BannerLandingActivities = function BannerLandingActivities(props) {
	    return _react2.default.createElement(
	        "section",
	        { id: "banner", className: "style2" },
	        _react2.default.createElement(
	            "div",
	            { className: "inner" },
	            _react2.default.createElement(
	                "header",
	                { className: "major" },
	                _react2.default.createElement(
	                    "h1",
	                    null,
	                    "Activities"
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "content" },
	                _react2.default.createElement(
	                    "h2",
	                    null,
	                    "Timeline and donors"
	                )
	            )
	        )
	    );
	};
	
	exports.default = BannerLandingActivities;
	module.exports = exports["default"];

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(25);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _BannerLandingActivities = __webpack_require__(211);
	
	var _BannerLandingActivities2 = _interopRequireDefault(_BannerLandingActivities);
	
	var _pic = __webpack_require__(512);
	
	var _pic2 = _interopRequireDefault(_pic);
	
	var _pic3 = __webpack_require__(131);
	
	var _pic4 = _interopRequireDefault(_pic3);
	
	var _pic5 = __webpack_require__(519);
	
	var _pic6 = _interopRequireDefault(_pic5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Landing = function Landing(props) {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            null,
	            _react2.default.createElement(
	                'title',
	                null,
	                'Activities'
	            ),
	            _react2.default.createElement('meta', { name: 'description', content: 'Activities' })
	        ),
	        _react2.default.createElement(_BannerLandingActivities2.default, null),
	        _react2.default.createElement(
	            'div',
	            { id: 'main' },
	            _react2.default.createElement(
	                'section',
	                { id: 'one' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'inner' },
	                    _react2.default.createElement(
	                        'header',
	                        { className: 'major' },
	                        _react2.default.createElement(
	                            'h2',
	                            null,
	                            'Activities'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        'Timeline and donors'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'section',
	                { id: 'two', className: 'spotlights' },
	                _react2.default.createElement(
	                    'section',
	                    null,
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { to: '/timeline', className: 'image' },
	                        _react2.default.createElement('img', { src: _pic2.default, alt: '' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'content' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'inner' },
	                            _react2.default.createElement(
	                                'header',
	                                { className: 'major' },
	                                _react2.default.createElement(
	                                    'h3',
	                                    null,
	                                    'Timeline'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'The Rana Plaza Coordination Committee was established on the 13th of September 2013. Since this date, the Committee worked tirelessly, along with the Rana Plaza Claims Administration, to ensure workers injured at Rana Plaza, and the surviving dependents of those killed received payments to cover the financial losses they incurred as a result of the disaster. Two years later, in October 2015,  over $30million had been dispersed to 5109 beneficiaries of the scheme.'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'The establishment, design and implementation of the Rana Plaza Arrangement was complex and required the RPCC to meet ambitious milestones in order to deliver its objective. You\'ll find here a timeline of the important events, and when they were achieved. '
	                            ),
	                            _react2.default.createElement(
	                                'ul',
	                                { className: 'actions' },
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        _gatsbyLink2.default,
	                                        { to: '/timeline', className: 'button' },
	                                        'Learn more'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'section',
	                    null,
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { to: '/trustfund', className: 'image' },
	                        _react2.default.createElement('img', { src: _pic6.default, alt: '' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'content' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'inner' },
	                            _react2.default.createElement(
	                                'header',
	                                { className: 'major' },
	                                _react2.default.createElement(
	                                    'h3',
	                                    null,
	                                    'Trust Fund and full Donor list'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'The Rana Plaza Donors Trust Fund was established in January 2014 by the International Labour Organization (ILO) in order to collect contributions and to hold them in trust under specified Terms and Conditions.  It was agreed that $30 million would be required to cover all awards, a figure developed on the basis of the actual claims forms submitted by eligible beneficiaries.'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'The Fund reached its target in June 2015. The majority of the $30 million collected was contributed by international clothing brands, with significant contributions from the Bangladesh Prime Ministers Fund and anonymous donors as well as small individual donations. These contributions were used exclusively to cover payments to Rana Plaza victims and their families, to provide medical services to those injures, and cover operating costs.'
	                            ),
	                            _react2.default.createElement(
	                                'ul',
	                                { className: 'actions' },
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        _gatsbyLink2.default,
	                                        { to: '/trustfund', className: 'button' },
	                                        'Learn more'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Landing;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-activities-js-ac52e56ecd1855ae4995.js